import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { VoipAlertsModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';


@Component({
  selector: 'app-manage-voip-alerts',
  templateUrl: './manage-voip-alerts.component.html',
  styleUrls: ['./manage-voip-alerts.component.css']
})
export class ManageVoipAlertsComponent implements OnInit {

  tokenKey: string = '';
  userId: number = 0;
  SelectedTool: string;
  productId: number = 1;
  multiSelectDropDownHeight: number = 200;

  VoipAlertsModel = new VoipAlertsModel()

  addUpdateVoipAlert = new FormGroup({
    updateId: new FormControl(''),
    updateDate: new FormControl(''),
    description: new FormControl(''),
    isNotify: new FormControl(0),
  });

  isVoipAlerts: boolean = true;
  updateId: number = 0;
  isDataLoad: boolean = false;
  isViewMode: boolean = false;

  isNotify: boolean = true;

  pageNumber:number;
  pageSize:number;
  Email:string = '';
  Name:string = '';
  orderBy:string;
  updateCategoryName:string;
  
  constructor(private readonly activedRoute: ActivatedRoute, 
    private readonly checkAuth: CheckAuth, 
    private readonly trfaAlertServices:TrfaAlertService,
    private readonly toastr: ToastrService, 
    private readonly router: Router,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
      this.tokenKey = this.sessionStorageService.getTokenValue();
      this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
      this.SelectedTool = this.sessionStorageService.getUserLoginTool();
      this.productId = ToolEnum.voip;
      this.titleService.setTitle('Manage VoIP Alert');
    }
    ngOnInit() {
      this.pageNumber = 1;
      this.pageSize = 10;
      this.orderBy = 'updateId ASC'
      this.activedRoute.params.subscribe((params: Params) => {
  
        if (params['id']) {
          if (params['id'] != null) {
            this.isVoipAlerts = false;
            this.updateId = params['id'];
            this.userId = params['userid'];
            this.GetVoipAlertsByUsers();
          }
        }
        else {
          this.userId = 0;
        }
      });
    }
    tokenExpireCalculation(startDate: string, tokenExpiry: string) {
      this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
    }
    
    GetVoipAlertsByUsers(): void {
      this.isDataLoad = true;
      this.trfaAlertServices.GetVoipAlertsByUser(this.tokenKey, this.updateId,this.pageNumber,this.pageSize,this.userId,this.orderBy,this.productId).subscribe(
        data => {
          if (data["voipAlertuser"] != null && data["status"] != "Failure") {
  
            this.VoipAlertsModel = data['voipAlertuser'][0];
  
            this.Email=this.VoipAlertsModel.email;
            this.Name=this.VoipAlertsModel.name;
            this.updateCategoryName=this.VoipAlertsModel.updateCategoryName;
  
            if (this.VoipAlertsModel != null) {
              const updateDate = new Date(this.VoipAlertsModel.updateDate);
            
              let dd1 = updateDate.getDate().toString();
              if (parseInt(dd1) < 10) {
                dd1 = '0' + dd1;
              }
            
              let mm1 = (updateDate.getMonth() + 1).toString();
              if (parseInt(mm1) < 10) {
                mm1 = '0' + mm1;
              }
            
              this.VoipAlertsModel.updateDate = `${mm1}/${dd1}/${updateDate.getFullYear()}`;
            }
  
            this.addUpdateVoipAlert.setValue({
              updateId: this.VoipAlertsModel.updateId,
              updateDate: this.VoipAlertsModel.updateDate,
              description: this.VoipAlertsModel.description,
              isNotify: this.VoipAlertsModel.isSendMail
            });
  
            this.isDataLoad = false;
          }
          else {
            this.isDataLoad = false;
            this.showMessage(data["message"], 'Error', 'error');
          }
        }, error => {
          this.isDataLoad = false;
          this.showMessage(error, 'Error', 'error');
        })
  
    }
  
  
    showMessage(msg: string, msgTitle: string, msgType: string) {
      if (msgType == 'success') {
        setTimeout(() => this.toastr.success(msg, msgTitle));
      }
      else if (msgType == 'error') {
        setTimeout(() => this.toastr.error(msg, msgTitle));
      }
    }
  
    isAlertDate(dateArray: any) {
      if (dateArray != null) {
        let dd1 = dateArray.getDate().toString();
        if (parseInt(dd1.toString()) < 10)
          dd1 = '0' + dd1.toString();
  
        let mm1 = (dateArray.getMonth() + 1).toString();
        if (parseInt(mm1.toString()) < 10)
          mm1 = '0' + mm1.toString();
  
        this.VoipAlertsModel.updateDate = mm1 + '/' + dd1 + '/' + dateArray.getFullYear();
      }
      else
        this.VoipAlertsModel.updateDate = null;
    }
  
    saveAddUpdateVoipAlert(addUpdateVoipAlert: any) {
      if (addUpdateVoipAlert.value['updateDate'] == '') {
        this.showMessage('Please select alert date', 'Error', 'error');
        return;
      }
      let currentDate = new Date();
      if (new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) > addUpdateVoipAlert.value["updateDate"]) {
        this.showMessage('Previous alert date not allow', 'Error', 'error');
        return;
      }
  
      if (addUpdateVoipAlert.value['description'] == '' || typeof (addUpdateVoipAlert.value['description']) == 'undefined') {
        this.showMessage('Please enter description', 'Error', 'error');
        return;
      }
      if (addUpdateVoipAlert.value['description'] != '') {
        if (addUpdateVoipAlert.value['description'].toString().trim() == '') {
          this.showMessage('Please enter description', 'Error', 'error');
          return;
        }
      }
  
      if (typeof (addUpdateVoipAlert.value['updateId']) == 'undefined') {
        this.VoipAlertsModel.updateId = 0;
      }
      else {
        this.VoipAlertsModel.updateId = addUpdateVoipAlert.value['updateId'];
      }
  
      if (typeof (addUpdateVoipAlert.value['description']) == 'undefined') {
        this.VoipAlertsModel.description = '';
      }
      else {
        this.VoipAlertsModel.description = addUpdateVoipAlert.value['description'];
      }
      this.VoipAlertsModel.isSendMail = this.isNotify;
      this.VoipAlertsModel.userId = this.userId;
      this.VoipAlertsModel.updateDate=addUpdateVoipAlert.value['updateDate'];
      this.VoipAlertsModel.productId=this.productId;
     
      this.trfaAlertServices.AddUpdateVoipAlerts(this.tokenKey, this.VoipAlertsModel).subscribe(
        data => {
          if (data['status'] == 'Success') {
            this.showMessage('Voip alerts Updated successfully', 'Success', 'success');
            this.router.navigate(['/admin/voip/voip-Alerts']);
          }
          else
            this.showMessage(data['status'], 'Error', 'error');
        },
        error => {
          this.showMessage(error, 'Error', 'error');
        }
      );
    }
    
    removeHTMLTags(str) {
      if ((str === null) || (str === ''))
        return false;
      else
        str = str.toString();
      return str.replace(/<[^>]*>/g, '');
    }
  
    setSendEmailNotificationChecked($event) {
      this.isNotify = $event.target.checked;
    }

}
